import React from 'react';
import Dispatcher from '../../dispatchers/Dispatcher';

export default class ExitGameModal extends React.Component {
    exitGame = () => {
        window.location.reload();
    }

    cancel = () => {
        Dispatcher.dispatch({
            type: 'video-toggle-end-modal', 
            data: { 
                modal: 'exit-game',
                open: false
             } 
        });
    }

    render() {
        return (
            <div className={`modal-overlay team ${this.props.open ? 'open' : ''}`}>
                <div className="modal-content">
                    <div className="section">
                        <h1>Exit Game (Delete data)</h1>
                        <div className="btn-row-6-stack">
                            <div className="btn" onClick={this.exitGame}>
                                <span>Exit Game</span>
                            </div>
                            <div className="btn" onClick={this.cancel}>
                                <span>Cancel</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
